export function normalizeCategorySegment(
  categorySegment: any,
  attributeValues?: IAttributeValue[]
): ICategorySegment {
  if (categorySegment) {
    return {
      ...categorySegment,
      //@ts-ignore
      unit: categorySegment.unit?.name,
      // refine category attributes on line item update change
      category_attributes: (categorySegment.category?.categoryAttributes || [])
        .filter((a: ICategoryAttribute) => a.question && a.required)
        .map((attribute: ICategoryAttribute) => ({
          ...attribute,
          question_short_text: attribute.questionTextShort,
          metric: attribute.displayMetric,
          attribute_detail: {
            id: attribute.attributeDetailId,
            attribute_type: attribute.attributeType,
            feature_values: attribute.featureValues
          },
          attribute_value: attributeValues?.find(
            (i) => i.attributeDetailId === attribute.attributeDetailId
          )
        }))
    }
  }
}
